module.exports = __webpack_public_path__ + "static/media/kidsartkids_01_C.df23262d.png";